import { useCallback, useEffect } from 'react';

import { type BaseFeatureFlags } from '../../launch-darkly.types';
import {
  deleteFeatureFlagsOverridesQueryParams,
  getFeatureFlagOverridesFromInitialUrl,
} from './utils';

// ─────────────────────────────────────────────────────────────────────────────

export const useQueryParamsOverridesEffect = <
  FeatureFlags extends BaseFeatureFlags,
>(
  params: Params<FeatureFlags>,
) => {
  const { onQueryParamsDetected } = params;

  // ─── Helpers ─────────────────────────────────────────────────────────

  const detectQueryParamsOverrides = useCallback(async () => {
    const filteredQueryParams = await getFeatureFlagOverridesFromInitialUrl<FeatureFlags>(); // prettier-ignore

    if (!filteredQueryParams) return;

    onQueryParamsDetected(filteredQueryParams);

    await deleteFeatureFlagsOverridesQueryParams();
  }, [onQueryParamsDetected]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    void detectQueryParamsOverrides();
  }, [detectQueryParamsOverrides]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params<FeatureFlags extends BaseFeatureFlags> = {
  onQueryParamsDetected: (overrides: Partial<FeatureFlags>) => void;
};
